import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService, ZipYiService, LoaderService, TrxService, MobileSSOService } from '~services';
import { FeatureFlagService } from '~services/feature-flag/feature-flag.service';
import { Utils } from './utils/utilities';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet *ngIf="appLoaded"></router-outlet>
    <app-loader></app-loader>
  `,
  standalone: false,
})
export class AppComponent {
  appLoaded = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private zipYiService: ZipYiService,
    private loaderService: LoaderService,
    private trxService: TrxService,
    private featureFlagService: FeatureFlagService,
    private mobileSSOService: MobileSSOService,
  ) {
    (window as any).callbackFromMobileApp = this.mobileSSOService.handleMobileAppCallback;

    router.events.subscribe(async (evt) => {
      if (evt instanceof NavigationEnd) {
        await trxService.sendPageEvent();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.loaderService.show();
    await this.featureFlagService.init({
      userId: this.authService.customerId || null,
    });

    if (!window.location.pathname.includes('/auth/mobilesso')) {
      await this.authService.initialise();
    }

    this.featureFlagService.initShopCentralFeature();
    this.router.initialNavigation();
    await this.zipYiService.initialize();
    this.appLoaded = true;
    this.loaderService.hide();
    this.trxService.funnelStartEvent(Utils.getFunnelSource());
  }
}
